export default {
  development: 'development',
  production: 'production',
};
